<template>
  <div class="navbar">
    <div style="display: flex;justify-content: flex-start;flex-grow: 1;">
      <div :style="{width: sidebar.opened?(isZh?'160px':'220px'):'1px'}" />
    </div>
    <div class="right-menu">
      <div id="account-info" style="display: inline-block">
        <el-tooltip :content="tenantName" effect="dark" placement="bottom">
          <div style="display: inline-block;padding-right: 20px;"><span>{{ $t('Tool.platformId') }}：</span> <span
            style="color:#999"
          >{{ tenantId }}</span></div>
        </el-tooltip>
        <div style="display: inline-block;padding-right: 20px;"><span>{{ $t('Tool.User') }}：</span> <span
          style="color:#999"
        >{{ isZh ? $store.getters.userInfo.chineseName : $store.getters.userInfo.englishName }}</span></div>
        <span v-if="$store.getters.userInfo.groupCompany">{{ $t('Tool.company') }}：</span>
        <el-tooltip
          :content="currentOfficeIdTip"
          placement="bottom"
        >
          <div class="company-select">
            <template v-if="$store.getters.userInfo.groupCompany">
              <owned-branch-tree
                v-if="ownedBranchStyle === 'level'"
                :office-list="currentOfficeList"
                :value="currentOfficeId"
                :width-auto-fit="true"
                :min-width="85"
                :max-width="196"
                @input="onOfficeInput"
                @tipChange="p=>{currentOfficeIdTip=p}"
              />
              <cargo-owned-branch-select
                v-else
                :value="currentOfficeId"
                :static-options="currentOfficeList"
                :width-auto-fit="true"
                style="min-width: 85px;max-width: 196px;"
                @input="onOfficeInput"
                @tipChange="p=>{currentOfficeIdTip=p}"
              />
            </template>
          </div>
        </el-tooltip>
        <span style="padding-left: 5px;">{{ $t('Tool.department') }}：</span>
        <el-select v-model="currentDeptId" filterable style="width: 120px;">
          <el-option
            v-for="dept in currentDeptList"
            :key="dept.uuid"
            :value="dept.departmentId"
            :label="isZh?dept.chineseName:dept.englishName"
          />
        </el-select>
        <span v-if="userGroups.length > 0 && curUserGroup" style="padding-left: 5px;">{{ $t('CargoMsg.Cargo_RoleGroup') }}：</span>
        <el-select v-if="userGroups.length > 0 && curUserGroup" v-model="curUserGroup" filterable style="width: 120px;" @change="changeUserGroup">
          <el-option
            v-for="group in userGroups"
            :key="group.uuid"
            :value="group.uuid"
            :label="group.groupName"
          />
        </el-select>
      </div>
      <!--铃铛消息-->
      <sys-message id="message-reminder" ref="sysMessage" class="right-menu-item" />
      <el-tooltip :content="$t('Menu.Menu1')" effect="dark" placement="bottom">
        <navbar-menu id="navbar-menu" class="right-menu-item" />
      </el-tooltip>
      <template v-if="!isProd">
        <el-tooltip content="前端开发规范" effect="dark" placement="bottom">
          <help-center class="screenfull right-menu-item" />
        </el-tooltip>
      </template>
      <template v-if="device!=='mobile'&&false">
        <div
          class="organization-wrap"
          style="display:inline-block;vertical-align: top;line-height:20px;padding-right:14px;color:#97a8be"
        >
          {{ userInfo.userName }} | {{ userInfo.departmentName }} | {{ userInfo.officeName }} | {{ userInfo.tenantId }}
        </div>

        <el-tooltip :content="$t('Message.FullScreen')" effect="dark" placement="bottom">
          <screenfull class="screenfull right-menu-item" />
        </el-tooltip>

        <el-tooltip :content="$t('Menu.HelpCenter')" effect="dark" placement="bottom">
          <help-center class="screenfull right-menu-item" />
        </el-tooltip>

        <el-tooltip :content="$t('Message.EarlyWarningReminder')" effect="dark" placement="bottom">
          <warning-alert class="screenfull right-menu-item" />
        </el-tooltip>

        <el-tooltip :scontent="$t('Message.AnnouncementMessage')" effect="dark" placement="bottom">
          <board-message class="screenfull right-menu-item" />
        </el-tooltip>

        <el-tooltip :content="$t('Menu.OnlineCustomerService')" effect="dark" placement="bottom">
          <custom-service class="screenfull right-menu-item" />
        </el-tooltip>
        <user-info
          class="screenfull right-menu-item"
          @change-password-from-user-info-because-of-shit="$emit('change-password-from-navbar-because-of-shit')"
        />
        <el-tooltip :content="$t('Message.Cancellation')" effect="dark" placement="bottom">
          <logout class="screenfull right-menu-item" />
        </el-tooltip>
      </template>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import MarqueeText from 'vue-marquee-text-component'
import Breadcrumb from '@/components/Breadcrumb'
import Hamburger from '@/components/Hamburger'
import Screenfull from '@/components/Screenfull'
import HelpCenter from '@/components/HelpCenter'
import WarningAlert from '@/components/WarningAlert'
import BoardMessage from '@/components/BoardMessage'
import CustomService from '@/components/CustomService'
import UserInfo from '@/components/UserInfo'
import Logout from '@/components/Logout'
import LangSelect from '@/components/LangSelect'
import ThemePicker from '@/components/ThemePicker'
import SysMessage from '@/components/Cargo/Common/SysMessage'
import NavbarMenu from '@/components/Cargo/Common/NavbarMenu'
import ChatDialog from '@/components/Cargo/Common/CargoIm/chatDialog'
import { getDeptId, getUserInfo } from '@/utils/auth'
import { cacheKeys, getFilterCacheList } from '@/utils/basicDataCache'
import { cache, cacheName } from '@/utils/cacheManager'
import { getLoading } from '@/utils/utilBaseElement'
import homeImg from '@/assets/icons/console.png'
import customerImg from '@/assets/icons/customerService.png'
import { getUserAllOfficePrivilege } from '@/api/auth'
import * as CommonUtil from '@/utils/commonUtil'
import CargoOwnedBranchSelect from '@/components/Cargo/Common/CargoOwnedBranchSelect'
import OwnedBranchTree from '@/components/Cargo/Common/OwnedBranchTree'
import router, { resetRouter } from '@/router'
import { basicCacheKeys } from '@/utils/cacheConfig'
import { UICustomUtil } from '@/class/cargo/model/utils/UICustomUtil'
import { getUserGroupsFunc } from '@/api/userGroup'
import LocalStorageUtils from '@/utils/localStorageUtils'

export default {
  name: 'Navbar',
  components: {
    Breadcrumb,
    Hamburger,
    Screenfull,
    HelpCenter,
    WarningAlert,
    BoardMessage,
    CustomService,
    UserInfo,
    Logout,
    LangSelect,
    ThemePicker,
    SysMessage,
    NavbarMenu,
    MarqueeText,
    ChatDialog,
    CargoOwnedBranchSelect,
    OwnedBranchTree
  },
  data() {
    const currentOfficeId = Number(this.$route.query.currentOfficeId)
    return {
      isShow: false, // 跑马临时展示控制
      carouselTimer: null, // 跑马灯轮询定时器
      closeIconShow: false, // 跑马灯关闭按钮展示控制
      duration: 15, // 跑马灯滚动速度
      noticeList: [], // 跑马灯列表
      loading: false,
      customerImg,
      homeImg,
      currentOfficeId: currentOfficeId || Number(this.$store.getters.currentOfficeId),
      currentOfficeIdTip: '',
      currentDeptId: 0,
      currentDeptList: [],
      unRead: 0,
      serviceMenuVisible: false,
      unreadTotal: 0,
      imUrl: '',
      imCacheKey: '',
      reconnectNumber: 0, // 重连次数
      curUserGroup: ''
    }
  },
  watch: {
    currentOfficeId(val) {
      this.currentOfficeIdChange(val).then(() => {
        if (this.permissionSeparateOffice) {
          this.reloadPermissionByOffice()
        }
      })
    },
    currentDeptId(val) {
      const currentDept = val === '' ? {} : this.currentDeptList.find(item => Number(item.departmentId) === Number(val))
      this.$store.dispatch('user/setCurrentDept', currentDept || {})
    }
  },
  computed: {
    ...mapGetters([
      'sidebar',
      'language',
      'isProd',
      'name',
      'avatar',
      'device'
    ]),
    carouselShow() {
      const carousel = this.$store.state.permission.carousel
      return !carousel || carousel === 1
    },
    isZh() {
      return this.language === 'zh'
    },
    userInfo() {
      return getUserInfo()
    },
    currentOfficeList() {
      return this.$store.state.user.userInfo.currentUserOfficeList
    },
    userGroups() {
      return this.$store.state.user.userGroups
    },
    tenantId() {
      const flag = this.userInfo.tenantLevel === 0 ? 'P' : 'E'
      const tenantId = this.userInfo.tenantId
      return `${flag}${tenantId}`
    },
    tenantName() {
      const flag = this.userInfo.tenantLevel === 0 ? this.$t('Message.FlagshipEdition') : this.$t('Message.BasicEdition')
      const tenantName = this.userInfo.tenantName
      return `${tenantName}(${flag})`
    },
    permissionSeparateOffice() {
      return this.$store.state.permission.permissionSeparateOffice
    },
    ownedBranchStyle() {
      return this.$store.state.settings.ownedBranchStyle
    }
  },
  async created() {
    const cacheDeptId = getDeptId(this.userInfo.userId, this.userInfo.tenantId)
    this.currentOfficeIdChange(this.currentOfficeId, cacheDeptId ? Number(cacheDeptId) : 0).then(async() => {
      if (this.permissionSeparateOffice === null) {
        await this.$store.dispatch('permission/setPermissionSeparateOffice', Number(cache.hqConfig.get('PermissionSeparateOffice')) === 1)
        if (this.permissionSeparateOffice) {
          const fullPath = this.$route.fullPath
          const loading = getLoading()
          try {
            const res = await getUserAllOfficePrivilege()
            await this.$store.dispatch('user/setRoles', res.data)
          } finally {
            loading.close()
          }
          const newFullPath = await this.reloadPermissionByOffice()
          if (newFullPath !== fullPath) {
            await CommonUtil.ensureExecuteSuccess(() => this.$route.fullPath !== fullPath)
            setTimeout(() => {
              this.$router.push(fullPath)
            })
          }
        }
      }
    })
    this.curUserGroup = LocalStorageUtils.getConfiguration('sessionGroupKey:' + this.userInfo.userId)
  },
  mounted() {
  },
  beforeCreate() {
    // console.log('navbar index')
  },
  methods: {
    toggleSideBar() {
      this.$store.dispatch('app/toggleSideBar')
    },
    async logout() {
      await this.$store.dispatch('user/logout')
      this.$router.push(`/login?redirect=${this.$route.fullPath}`)
    },
    async currentOfficeIdChange(val, cargoDeptId) {
      const currentOffice = this.currentOfficeList.find(item => Number(item.officeId) === Number(val))
      this.currentDeptList = getFilterCacheList(cacheKeys.basic_data_Department, (item) => {
        return item.officeUuid === currentOffice.uuid
      }) || []

      if (cargoDeptId && this.currentDeptList.findIndex(item => item.departmentId === cargoDeptId) >= 0) {
        this.currentDeptId = cargoDeptId
      } else {
        this.currentDeptId = this.currentDeptList.length > 0 ? this.currentDeptList[0].departmentId : ''
      }
      CommonUtil.getTimeZone(currentOffice) // 当前分公司所设置的时区
      this.$store.dispatch('user/setCurrentOffice', currentOffice || {})
      CommonUtil.setBpmJobCharge() // 当前分公司是否开启“业务费用申请单”审批流
      await this.toSyncData()
      this.$store.dispatch('frontEndPlugin/setConfig', { enable: Number(cache.config.get('enableFrontEndPlugin')), url: String(cache.config.get('frontEndPluginUrl')), urlProd: String(cache.config.get('frontEndPluginUrlProd')) }) // 是否启用丰收前端插件
    },
    async toSyncData() {
      // 分公司切换时，同步一些基础数据
      this.loading = getLoading()
      await cache.reload([{ name: cacheName.CONFIG, clear: true }])
      this.loading.close()
    },
    handleServiceCommand(command) {
      switch (command) {
        case 'onlineService':
          console.log('onlineService')
          break
        default:
          break
      }
    },
    async onOfficeInput(val) {
      if (val === this.currentOfficeId) {
        return
      }
      const { branchCountLimited, initBranchCount, validBranchCount } = this.$store.state.settings.bsLimitInfo
      if (branchCountLimited && validBranchCount >= 0 && val !== 1) {
        const officeList = getFilterCacheList(basicCacheKeys.basic_data_Office_All, p => p.officeId !== 1)
        if (officeList.length > initBranchCount + validBranchCount) {
          officeList.sort((a, b) => {
            const aTime = new Date(a.dateCreated).getTime()
            const bTime = new Date(b.dateCreated).getTime()
            return aTime - bTime
          })
          let isValid = false
          for (let i = 0; i < officeList.length && i < initBranchCount + validBranchCount; ++i) {
            if (officeList[i].officeId === val) {
              isValid = true
              break
            }
          }
          if (!isValid) {
            this.$confirm(this.$t('SystemMaintenance.BranchCountExpireLimitUse'), this.$t('SystemMaintenance.Prompt'), {
              confirmButtonText: this.$t('common.btn.ok'),
              cancelButtonText: this.$t('common.btn.cancel'),
              dangerouslyUseHTMLString: true,
              type: 'warning'
            }).then(() => {
              this.currentOfficeId = 1
            }).catch(() => {})
            return
          }
        }
      }
      if (this.permissionSeparateOffice) {
        const canCloseModule = this.$store.state.app.canCloseModule
        let openModuleCount = 0
        for (const view of this.$store.state.tagsView.visitedViews) {
          if (!view.meta.affix) {
            openModuleCount += 1
          }
        }
        const editingModuleCount = this.$store.state.app.canCloseModuleMap.size
        if (openModuleCount > 0) {
          let flag = false
          if (canCloseModule || editingModuleCount === openModuleCount) { // 编辑状态
            flag = await this.$confirm(this.$t('Message.SwitchBranchAndOpenModuleTipAllEdit', [openModuleCount]), this.$t('Message.Prompt'), {
              confirmButtonText: this.$t('common.btn.ok'),
              cancelButtonText: this.$t('common.btn.cancel'),
              closeOnClickModal: false,
              type: 'warning'
            }).then(() => true).catch(() => false)
          } else if (editingModuleCount === 0) { // 非编辑状态
            flag = await this.$confirm(this.$t('Message.SwitchBranchAndOpenModuleTipNotEdit', [openModuleCount]), this.$t('Message.Prompt'), {
              confirmButtonText: this.$t('common.btn.ok'),
              cancelButtonText: this.$t('common.btn.cancel'),
              closeOnClickModal: false,
              type: 'warning'
            }).then(() => true).catch(() => false)
          } else { // 既有编辑状态，又有非编辑状态
            flag = await this.$confirm(this.$t('Message.SwitchBranchAndOpenModuleTipPartEdit', [openModuleCount]), this.$t('Message.Prompt'), {
              confirmButtonText: this.$t('common.btn.ok'),
              cancelButtonText: this.$t('common.btn.cancel'),
              closeOnClickModal: false,
              type: 'warning'
            }).then(() => true).catch(() => false)
          }
          if (!flag) {
            return
          }
        }
      }
      if (Number(cache.hqConfig.get('UICustomization')) === 1) {
        const loading = getLoading()
        try {
          await UICustomUtil.loadUICustomPageInfo(this.$route.path, val)
        } finally {
          loading.close()
        }
      }
      this.currentOfficeId = val
    },
    // 根据分公司重新载入权限
    async reloadPermissionByOffice() {
      resetRouter()
      const loading = getLoading()
      try {
        const accessRoutes = await this.$store.dispatch('permission/generateRoutes', this.$store.getters.roles)
        router.addRoutes(accessRoutes)
        await Promise.all([
          this.$store.dispatch('permission/menuRefreshIdPlusOne'),
          this.$store.dispatch('tagsView/delAllViews'),
          this.$store.dispatch('app/setCanCloseModule', false)
        ])
        this.$store.state.app.canCloseModuleMap.clear()
        this.$router.push('/')
        return '/dashboard'
      } finally {
        loading.close()
      }
    },
    openSysMsg() {
      this.$refs.sysMessage.handleShowMessage()
    },
    changeUserGroup(value) {
      console.log('changeUserGroup', value)
      // 将当前用户组保存到本地存储
      LocalStorageUtils.setConfiguration('sessionGroupKey:' + this.userInfo.userId, value)
      // 添加 groupKey 参数并刷新页面
      window.location.href = window.location.origin
    }
  }
}
</script>

<style lang="scss" scoped>
@import "~@/styles/element-variables.scss";
.navbar {
  display: flex;
  height: 40px;
  overflow: hidden;
  position: relative;
  background: #fff;
  border-bottom: 1px solid $--border-color-lighter;

  .carousel {
    flex-grow: 1;
    max-width: 500px;
    position: relative;
    display: flex;
    align-items: center;
    margin-left: 20px;

    .carousel-close {
      position: absolute;
      cursor: pointer;
      top: 7px;
      right:0;
      width: 13px;
      height: 15px
    }

    .carousel-content {
      width: 350px;
      flex-grow: 1;
      background: #f0f3f8;
      border-radius: 8px;
      height: 25px;
      line-height: 25px;
      padding: 0 15px 0 5px;
      box-shadow: 0 0 8px #8e9cb133;

      .carousel-content-item {
        color: #1F75D5;
        display: inline-block;
        cursor: pointer;
        margin-right: 10px;
      }
    }
  }
  .hamburger-container {
    line-height: 36px;
    height: 100%;
    float: left;
    cursor: pointer;
    transition: background .3s;
    -webkit-tap-highlight-color:transparent;

    &:hover {
      background: rgba(0, 0, 0, .025)
    }
  }

  .breadcrumb-container {
    float: left;
  }

  .errLog-container {
    display: inline-block;
    vertical-align: top;
  }

  .right-menu {
    margin: 5px 5px 0 0;

    &:focus {
      outline: none;
    }

    .screenfull {
      height: 20px;
    }

    .company-select{
      display: inline-block;
    }

    .right-menu-item {
      display: inline-block;
      padding: 0 4px;
      line-height: 28px;
      height: 28px;
      vertical-align: top;
      color: #5a5e66;

      &.hover-effect {
        cursor: pointer;
        transition: background .3s;

        &:hover {
          background: rgba(0, 0, 0, .025)
        }
      }
    }
    .avatar-container {
      margin-right: 30px;

      .avatar-wrapper {
        margin-top: 5px;
        position: relative;

        .user-avatar {
          cursor: pointer;
          width: 40px;
          height: 40px;
          border-radius: 10px;
        }

        .el-icon-caret-bottom {
          cursor: pointer;
          position: absolute;
          right: -20px;
          top: 25px;
          font-size: 12px;
        }
      }
    }
  }
}

</style>
<style lang="scss">
.right-menu-item-im{
  cursor: pointer;
  .el-badge__content.is-fixed{
    top: 6px !important;
    right: 20px !important;
  }
}
.communicate .el-badge__content.is-fixed{
  top: 5px !important;
  right: 0 !important;
}
</style>
